export const RESET_STATE = "RESET_STATE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const FETCH_REACTIONS = "FETCH_REACTIONS";
export const UPDATE_REACTIONS = "UPDATE_REACTIONS";
export const REGISTER_REACTION = "REGISTER_REACTION";
export const SET_USER_TO_STATE = "SET_USER_TO_STATE";
export const SET_THEME_IMAGE = "SET_THEME_IMAGE"
